import { render } from "./ModalPack.vue?vue&type=template&id=7778238f&scoped=true"
import script from "./ModalPack.vue?vue&type=script&lang=js"
export * from "./ModalPack.vue?vue&type=script&lang=js"

import "./ModalPack.vue?vue&type=style&index=0&id=7778238f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7778238f"

export default script